import { gql } from '@apollo/client'

const REFRESH_ACCESS_TOKEN_MUTATION = gql`
  mutation refreshAccessToken($refreshToken: String!) {
    refreshAccessToken(refreshToken: $refreshToken)
  }
`

export default REFRESH_ACCESS_TOKEN_MUTATION
